import { CInputGroup } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarInputGroup = (props) => {
  const { children } = props
  return <CInputGroup {...props}>{children}</CInputGroup>
}

export { ConfiaCarInputGroup }
